module.exports = __webpack_public_path__ + "static/media/makeup_lip2.7916136b.jpg";